const state = {
  currentStep: 0,
  secondStepWindow: 'address',
  currentPaymentTab: 'paymentTypes',
  currentOtherWindow: undefined,
  showFoodWindow: false,
  courierComment: '',
  currentMenuItem: null,
  currentCategory: null,
  currentCollectionId: undefined,
  categories: null,
  client: null,
  showPromotionsWindow: false,
  showCommentKeyboard: false,
  isMenuItemsLoading: false,
  menuItemsList: [],
  collectionsList: [],
  newClientPhone: null,
  newOrderClientId: null,
  newOrderIncomingPhone: null,
  isDrinksSuggested: false,
  activeClientId: null,
  showResultWindow: false,
  searchMenu: '',
  availableSteps: [],
  callId: null,
  paymentMode: null,
  upsaleLabelText: 'Предложить допродажи',
}

const getters = {
  getAllMenuItems: state => {
    const items = []
    state.categories.forEach(category => items.push(...category.menuItems))
    return items
  },
}

const actions = {}

const mutations = {
  setSearchMenu (state, value) {
    state.searchMenu = value
  },
  setNewOrderClientId (state, value) {
    state.newOrderClientId = value
  },
  setNewOrderIncomingPhone (state, value) {
    state.newOrderIncomingPhone = value
  },
  setActiveClientId (state, value) {
    state.activeClientId = value
  },
  setNewClientPhone (state, value) {
    state.newClientPhone = value
  },
  setFoodWindowState (state, value) {
    state.showFoodWindow = value
  },
  setCurrentOtherWindow (state, value) {
    state.currentOtherWindow = value
  },
  closeOtherAndPromoWindows (state) {
    state.currentOtherWindow = undefined
    state.showPromotionsWindow = false
  },
  setCurrentPaymentTab (state, value) {
    state.currentPaymentTab = value
  },
  setDrinkDetailsStatus (state, value) {
    state.isDrinksSuggested = value
  },
  toggleCommentKeyboard (state, value) {
    state.showCommentKeyboard = value
  },
  setCourierComment (state, value) {
    state.courierComment = value
  },
  setStep (state, step) {
    state.availableSteps.push(step)
    state.currentStep = step
  },
  setCurrentClient (state, payload) {
    state.client = payload
  },
  setSecondStepWindow (state, value) {
    state.secondStepWindow = value
  },
  toggleResultWindow (state, value) {
    state.showResultWindow = value
  },
  togglePromotionsWindow (state, value) {
    state.showPromotionsWindow = value
  },
  realTogglePromotionsWindow (state) {
    state.showPromotionsWindow = !state.showPromotionsWindow
  },
  setMenuItemsLoading (state, value) {
    state.isMenuItemsLoading = value
  },
  setCurrentCollectionId (state, value) {
    state.currentCollectionId = value
  },
  setCollectionsList (state, value) {
    state.collectionsList = value
  },
  setCategories (state, categories) {
    state.categories = categories
  },
  setCurrentCategory (state, id) {
    state.currentCategory = id
  },
  setMenuItemsList (state, payload) {
    state.menuItemsList = payload
  },
  resetAvailableSteps (state) {
    state.availableSteps = []
  },
  setCallId (state, payload) {
    state.callId = payload
  },
  setPaymentMode (state, payload) {
    state.paymentMode = payload
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
